/**
 * Work archive, list mode: shows the hovered row's image in the shared sticky
 * panel beside the list (partials/project-hover-stack.php). The image can't live
 * in the row - a sticky box needs a tall parent to travel in - so the row/image
 * pairing can't be made in CSS either. Rows and images are rendered in the same
 * order, so the pairing is by index.
 *
 * Delegated from the list container, which survives the AJAX result swaps.
 */
const ROW = '.c-project--listed';

export default class ProjectListHover {
    constructor() {
        const list = document.querySelector('.js-work__list');

        if (!list) {
            return;
        }

        this.list = list;
        this.active = null;

        list.addEventListener('pointerover', (e) => this.onEnter(e));
        list.addEventListener('focusin', (e) => this.onEnter(e));
        list.addEventListener('pointerleave', () => this.clear());

        list.addEventListener('focusout', (e) => {
            if (!list.contains(e.relatedTarget)) {
                this.clear();
            }
        });
    }

    onEnter(e) {
        const row = e.target.closest?.(ROW);

        if (row) {
            this.activate(row);
        } else {
            // Pointer is in the list but off the rows (e.g. over the image column).
            this.clear();
        }
    }

    activate(row) {
        // Re-queried per event: both containers are replaced on every AJAX swap.
        const rows = this.list.querySelector('.js-work__list-rows');
        const stack = this.list.querySelector('.js-work__hover-stack');

        if (!rows || !stack) {
            return;
        }

        const media = stack.children[[...rows.children].indexOf(row)];

        if (!media || media === this.active) {
            return;
        }

        this.clear();
        media.classList.add('is-active');
        this.active = media;
    }

    clear() {
        this.active?.classList.remove('is-active');
        this.active = null;
    }
}
